angular.module('zc.zenclerkS')

  .component('zcsCampaignTemplateEditor', {
    bindings: {
      project: '=',
      campaign: '=',
      isInterestWidgetSettingsPage: '=',
    },
    templateUrl: '/templates/zenclerk_s/directives/campaign/template_editor/campaign_template_editor.html',
    controller: zcsCampaignTemplateEditor
  });

zcsCampaignTemplateEditor.$inject = ['$scope', '$translate', 'Campaign', 'Template'];
function zcsCampaignTemplateEditor($scope, $translate, Campaign, Template) {
  const vm = this;
  vm.lang = $translate.use();

  const COMMON_SETTINGS = {
    giftcard: [
      'coupon_pattern',
      'base_color',
      'limit',
      'giftcard_offer_message',
      'giftcard_free_shipping',
      'giftcard_code_message',
      'countdown_message',
      'code_condition',
      'giftcard_button',
      'giftcard_present_message',
      'code_name',
      'giftcard_guide',
      'code_description',
      'notice',
      'badge_position',
    ],
    giftcard_jp: [
      'coupon_pattern',
      'base_color',
      'limit',
      'giftcard_free_shipping',
      'code_condition',
      'code_description',
      'badge_position',
    ],
    zcs_textonly: [
      'base_color',
      'second_color',
      'limit',
      'zc_header',
      'zc_insentive_usage_requirement',
      'btntext_offer',
      'code_title',
      'code_name',
      'code_condition',
      'code_description',
      'btntext_present',
      'badge_position',
      'offer_hint',
      'notice',
    ],
    zcs_textonly_jp: [
      'base_color',
      'second_color',
      'limit',
      'zc_insentive_usage_requirement',
      'code_condition',
      'code_description',
      'badge_position',
    ],
    zcs_image: [
      'banner',
      'base_color',
      'second_color',
      'limit',
      'btntext_offer',
      'code_title',
      'code_name',
      'code_condition',
      'code_description',
      'btntext_present',
      'badge_position',
      'offer_hint',
    ],
    zcs_image_jp: [
      'banner',
      'base_color',
      'second_color',
      'limit',
      'code_condition',
      'code_description',
      'badge_position',
    ],
  };

  const IW_SETTINGS = [
    'primary_color',
    'badge_icon_color',
    'secondary_color',
    'widget_position',
    'widget_color_launcher',
    'widget_color_primary',
    'widget_color_secondary',
    'iw_item_name_text',
    'iw_coupon_name_text',
  ];

  const getAllowedSettings = () => {
    const templateName = vm.project.sales_entity === 'appier_jp'
      ? `${vm.campaign.template_type}_jp`
      : vm.campaign.template_type;
    const allowedSettings = vm.isInterestWidgetSettingsPage
      ? IW_SETTINGS
      : COMMON_SETTINGS[templateName];

    return vm.project.site_logo_image_id
      // do not show header if there is logo
      ? _.reject(allowedSettings, i => i === 'zc_header')
      : allowedSettings;
  };

  vm.$onInit = () => {
    vm.templateItems = {};
    vm.hasSetting = hasSetting;
    vm.allowedSettings = getAllowedSettings();

    // update the textonly template text when limit changes
    $scope.$watch('$ctrl.campaign.element.message.limit', newval => {
      if(_.get(vm.campaign, 'template_type') === 'zcs_textonly') {
        const int = parseInt(newval);
        let timeLimitText;
        if(int <= 61) {
          timeLimitText = $translate.instant('directives.common.minute', { minute: (int - 1) });
        } else {
          timeLimitText = $translate.instant('directives.common.hour', { hour: (int - 1) / 60 });
        }
        vm.campaign.element.message.zc_insentive_requirement = $translate.instant('directives.campaign.templateEditor.editor.timeLimit', { limit: timeLimitText });
      }
    });

    $scope.$watch('$ctrl.campaign.element.message.offer_hint', newval => {
      if(vm.campaign.template_type === 'zcs_image') {
        vm.campaign.element.message.present_hint = newval;
      }
    });

    $scope.$watch('$ctrl.campaign.template', newval => {
      if(_.get(vm.campaign, 'template_type') === 'zcs_image' && !vm.campaign.element.message.banner) {
        vm.campaign.element.message.banner = `${ZC_CONFIG.RAILS_API_URL}:${ZC_CONFIG.RAILS_API_PORT}/assets/campaigns/coupon/default/sample_280x280.${vm.lang}.png`;
      }

      if(newval) {
        vm.allowedSettings = getAllowedSettings();

        // make template items into key/value instead of array,
        // for easier view side accessibility
        vm.templateItems = {};
        _.each(newval.template, d => {
          vm.templateItems[d.name] = d;

          // To solve a problem caused by 1-click buy feature in shopify projects:
          // https://github.com/zenclerk/zenclerk/issues/9832
          if(d.name === 'code_condition' && vm.project.integrated_with === 'shopify') {
            vm.templateItems[d.name].description = $translate.instant('directives.campaign.templateEditor.editor.shopifyCodeCondition');
          }

          if(d.name === 'offer_hint') {
            vm.templateItems[d.name].label = $translate.instant('sharedModules.campaignsTemplate.offerHint.label_short');
          }
        });

        if(vm.campaign.element.message.discount_type !== 'free_shipping') {
          delete vm.templateItems.giftcard_free_shipping;
        }
      }
    });

    $scope.$watch('$ctrl.campaign.element', function(newval) {
      if(newval) {
        // giftcard pattern handler
        if(_.get(vm.campaign, 'element.message.coupon_pattern', '').indexOf('http') === 0) {
          vm.campaign.userPattern = true;
        }
      }
    });
  };

  function hasSetting(name) {
    if(!vm.campaign || !vm.campaign.template) { return false }

    for(let item of Array.from(vm.campaign.template.template)) {
      if(item.name === name) {
        return true;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/campaign/template_editor/campaign_template_editor.js